import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OAuthViewModel } from "../../features/oauth/oauth-viewmodel";
import { useViewModel } from "../../viewmodel/use-view-model";
export const OAuthLogout = () => {
    const vm = useViewModel(OAuthViewModel);
    const { t } = useTranslation();
    useEffect(() => {
        vm.logout();
        setTimeout(() => {
            window.location.href = `/#`;
            window.location.reload(); // force reload page to create all app from the ground up
        }, 10);
    }, []);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "d-flex justify-content-center align-items-center", children: _jsxs("div", { className: "card mt-5 mt-5 w-50", children: [_jsx("h6", { className: "card-header pt-2 pb-2", children: t("oauth.logout") }), _jsx("div", { className: "card-body", children: t("oauth.loggingOut") })] }) }) }));
};
